import { render, staticRenderFns } from "./AddHolidayOfMonth.vue?vue&type=template&id=fe605838&"
import script from "./AddHolidayOfMonth.vue?vue&type=script&lang=js&"
export * from "./AddHolidayOfMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports